import { Message } from "../types";

/**
 * Decides which message, if any, autoplay should speak on a given render.
 *
 * `unseen` is the messages that have appeared since the last time the chat
 * window looked — already filtered to the active persona, in display order.
 *
 * Batch size is what separates a live reply from a history load, and it needs
 * no clock to do it. A reply arrives on its own: the user's message was
 * appended in an earlier render, so the model turn lands alone. A history load
 * — entering a session, switching persona, the messages array repopulating
 * after a session change — hydrates the whole conversation at once. A
 * single-message history can only ever be the user's opening line, which is
 * not spoken anyway.
 */
export function selectAutoplayMessage(unseen: Message[]): Message | null {
  if (unseen.length !== 1) return null;
  const [candidate] = unseen;
  // Failure notices render as model turns but are not the persona speaking.
  if (candidate.role !== "model" || candidate.isError) return null;
  if (!candidate.text.trim()) return null;
  return candidate;
}
